import React from "react";
import logo from "../assets/images/logo.png"; // Essar Logo

const LoadingSpinner = ({ text = "Loading records..." }) => {
    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", minHeight: "300px" }}>
            <style>
                {`
          @keyframes pulse-animation {
            0% { transform: scale(0.9); opacity: 0.6; }
            50% { transform: scale(1.1); opacity: 1; }
            100% { transform: scale(0.9); opacity: 0.6; }
          }
        `}
            </style>
            <img
                src={logo}
                alt="Loading..."
                style={{ width: "60px", animation: "pulse-animation 1.5s infinite ease-in-out" }}
            />
            <p style={{ marginTop: "16px", color: "#8c8c8c", fontSize: "16px" }}>{text}</p>
        </div>
    );
};

export default LoadingSpinner;